import {WindowService} from "../../../app-react/services/window/window.service";
import {IWindowService} from "../../../app-react/services/window/window.service.interface";
import ClientTools from "../../utils/client-tools/client-tools";
import {IInsideOrbitMenuServices} from "./inside-orbit-menu.service.interface";
import {ILocationService} from "../../../app-react/services/location/location.service.interface";
import {IStorageService} from "../../../app-react/services/storage/storage.service.interface";

export class InsideOrbitMenuService implements IInsideOrbitMenuServices{
    readonly location: ILocationService;
    readonly window: IWindowService;
    readonly clientTools: any;
    readonly storage: IStorageService;

    constructor(proxyService: any, locationService: ILocationService, storage: IStorageService) {
        this.clientTools = new ClientTools(proxyService);
        this.window = new WindowService();
        this.location = locationService;
        this.storage = storage;
    }
}